export default __webpack_public_path__ + "static/media/order_2.12e320c6.png";